import React from "react";
import TableTemplate from "../TableTemplate/tableTemplate";
import {
  OrderBookReport,
  OrderBookSearchParam,
} from "../../Interfaces/orderBookSamplingInterfaces";
import { getSamplingTable } from "../../Requests/OrderBookSampling/orderbookSamplingRequests";
import OrderBookTableUI from "./OrderBookSamplingTableUI";
import OrderBookSearchParamUI from "./OrderBookSamplingSearchParamUI";

const OrderBookSamplingTable = () => {
  return (
    <TableTemplate<OrderBookSearchParam, OrderBookReport>
      getDataTable={getSamplingTable}
      TableUI={OrderBookTableUI}
      SearchParamUI={OrderBookSearchParamUI}
      initialSearchParameters={{}}
    />
  );
};

export default OrderBookSamplingTable;
